import React from "react";

type Props = {
  /** Ghost rows in the left rail (persona = 4 fields, questions = 5 topics). */
  rails?: number;
  /** Ghost lines in the right panel body. */
  lines?: number;
  /** Render a textarea-sized block instead of single-line input (description). */
  block?: boolean;
};

/** Loading placeholder that mirrors the real wizard picker — the left rail of
 *  cards plus the right panel's header + form — so the skeleton occupies the
 *  same shape (and reflows the same way on mobile) as the content it replaces.
 *  Used while Marcus drafts the persona and while questions generate. */
export function PickerSkeleton({ rails = 4, lines = 2, block = false }: Props) {
  return (
    <div className="picker picker--skeleton" aria-busy="true" aria-live="polite">
      <span className="sr-only">Loading…</span>
      <div className="cats">
        {Array.from({ length: rails }).map((_, i) => (
          <div key={i} className="cat-card" aria-hidden="true">
            <span className="ic vb-skel" />
            <span className="body">
              <span className="vb-skel vb-skel-line" style={{ width: "62%" }} />
              <span className="vb-skel vb-skel-line vb-skel-line--sm" style={{ width: "88%" }} />
            </span>
            <span className="vb-skel vb-skel-chip" />
          </div>
        ))}
      </div>
      <div className="panel" aria-hidden="true">
        <div className="panel-hd">
          <span className="vb-skel vb-skel-line vb-skel-line--title" style={{ width: "40%" }} />
          <span className="vb-skel vb-skel-line vb-skel-line--sm" style={{ width: "70%" }} />
        </div>
        {block ? (
          <span className="vb-skel vb-skel-field vb-skel-field--block" />
        ) : (
          <>
            {Array.from({ length: lines }).map((_, i) => (
              <span key={i} className="vb-skel vb-skel-line" style={{ width: i % 2 ? "82%" : "95%" }} />
            ))}
            <span className="vb-skel vb-skel-field" />
          </>
        )}
      </div>
    </div>
  );
}

export default PickerSkeleton;
